import { useEffect, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";
import FaqAccordion, { buildFaqPageSchema } from "@/components/feature/FaqAccordion";
import EnquiryModal from "@/components/feature/EnquiryModal";
import { brand } from "@/mocks/siteData";
import { konaseemaGallery } from "@/mocks/konaseemaData";
import { useTripPlannerData } from "@/hooks/usePublicGuide";
import { usePublicFaqs } from "@/hooks/usePublicContent";
import { planTripFaqs } from "./planTripFaqs";
import TripHero from "./components/TripHero";
import TripPresets from "./components/TripPresets";
import TripBuilder from "./components/TripBuilder";
import TripKnowBefore from "./components/TripKnowBefore";
import TripCta from "./components/TripCta";

export default function PlanTrip() {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const faqs = usePublicFaqs("Trip Planning", planTripFaqs);
  const { presets } = useTripPlannerData();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const itineraryOptions = [
    { value: "Custom itinerary", label: "Custom itinerary — built for me" },
    ...presets.map((preset) => ({
      value: preset.title,
      label: `${preset.title} · ${preset.duration}`,
    })),
  ];

  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Seo
        title={`Konaseema Farm Trip Planner | ${brand.name}`}
        description="Plan a farm trip to Konaseema, Andhra Pradesh. Build a day-by-day itinerary, add farm experiences and check the best season, travel tips and how to get here."
        path="/plan-your-trip"
        keywords="plan Konaseema trip, farm trip itinerary, agri tourism planning, Konaseema itinerary builder, farm visit booking, when to visit Konaseema"
        image={konaseemaGallery[0].src}
        structuredData={buildFaqPageSchema(faqs)}
      />
      <Navbar />
      <main>
        <TripHero />
        <TripPresets />
        <TripBuilder onBuildItinerary={() => setEnquiryOpen(true)} />
        <TripKnowBefore />
        <FaqAccordion
          faqs={faqs}
          eyebrow="Trip Planning"
          title="Planning Your Farm Trip FAQs"
          intro="The questions travellers ask most while planning — booking lead time, mixing farms, how many days to allow and what to pack."
          className="sun-glaze bg-background-100"
        />
        <TripCta />
        <EnquiryModal
          open={enquiryOpen}
          onClose={() => setEnquiryOpen(false)}
          kind="trip"
          options={itineraryOptions}
          defaultValue="Custom itinerary"
        />
      </main>
      <Footer />
    </div>
  );
}